import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'Text';
import { ExamInfoBox } from './ExamInfoBox';
import '../locales/streamDashboard/streamDashboard-en.json';

/*
    Off-scale on purpose: the score is 72px to match the legacy box. The caption stays at 20px; the legacy 72px
    caption looked like a cascade accident.
*/

type Props = {
    // Already formatted, including the percent sign. See getExamScore.
    examScore: string | null;
    className?: string;
};

export const ExamScoreBox: FC<Props> = ({ examScore, className }) => {
    const { t } = useTranslation('back_royal', { keyPrefix: 'streamDashboard.streamDashboard' });

    if (!examScore) return null;

    return (
        <ExamInfoBox caption={t('exam_score')} alwaysShowDivider uppercaseCaption centerBody className={className}>
            <Text as="p" className="m-0 text-[72px] font-semibold text-black">
                {examScore}
            </Text>
        </ExamInfoBox>
    );
};
